import * as React from "react";
import { Dialog } from "./../Dialog/Dialog";
import { Icon } from "../Icon/icon";

export interface ButtonModalProps {
  buttonText: string;
  buttonCss: string;
  modalAction: string;
  modalHeading: string;
  modalBody: string;
  modalCancelText: string;
  modalCancelCss: string;
  modalActionText: string;
  modalActionCss: string;
  modalActionUrl?: string;
  callBackLink?: string;
  isButtonDisabled?: boolean;
  onActionCompleted?(): void;
}

export interface ButtonModalState {
  isModalOpen: boolean;
}

/**
 * Renders a button that opens a modal dialogue with the given properties. See [[ButtonModalProps]] for available options.
 */
export class ButtonModal extends React.Component<
  ButtonModalProps,
  ButtonModalState
> {
  constructor(props: ButtonModalProps) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  static defaultProps = {
    modalActionUrl: "",
    callBackLink: "",
    onActionCompleted: () => {},
  };

  onActionCompleted = () => this.props.onActionCompleted();

  openConfirm = (e: React.MouseEvent) => {
    e.preventDefault();

    this.setState({
      isModalOpen: true,
    });
  };

  closeConfirm = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  redirect = () => this.props.onActionCompleted;

  doAction = () => {
    //const { modalActionUrl } = this.props
    this.closeConfirm();
    this.onActionCompleted();
  };

  public render() {
    const {
      buttonText,
      buttonCss,
      modalAction,
      modalHeading,
      modalBody,
      modalCancelText,
      modalActionText,
      modalActionUrl,
      callBackLink,
      modalActionCss,
      modalCancelCss,
      isButtonDisabled,
    } = this.props;

    const { isModalOpen } = this.state;

    return (
      <div>
        {!isButtonDisabled && (
          <button
            type="button"
            onClick={this.openConfirm}
            className={buttonCss}
          >
            {buttonText}
          </button>
        )}
        {isButtonDisabled && (
          <button type="button" className="button" disabled>
            {buttonText}
          </button>
        )}
        <Dialog isOpen={isModalOpen} onRequestClose={this.closeConfirm}>
          <button type="button" onClick={this.closeConfirm} className="close">
            <Icon
              isAriaHidden={false}
              ariaLabel="Stäng"
              iconType="ic_close_white_24px"
            />
          </button>

          <div className="header">
            <h2>{modalHeading}</h2>
          </div>
          <p>{modalBody}</p>
          <div className="footer">
            <button
              type="button"
              className={modalCancelCss}
              onClick={this.closeConfirm}
            >
              {modalCancelText}
            </button>
            <button
              type="button"
              className={modalActionCss}
              onClick={this.doAction}
            >
              {modalActionText}
            </button>
          </div>
        </Dialog>
      </div>
    );
  }
}
